import { isDate } from "lodash";
import moment from "moment";
import { ReactNode, useEffect, useMemo, useRef, useState } from "react";
import { DateRangeType, DateValueType } from "react-tailwindcss-datepicker";
import { myTaskMeetingsListName } from "src/api/config/meetings.config";
import { myTaskActionsListName, myTaskActionsStatusesListName } from "src/api/config/myTasksActions.config";
import {
  myTasksDepartmentsListName,
  myTasksDependListName,
  myTasksLocationsListName,
} from "src/api/config/myTasksLists.config";
import { Breadcrumbs } from "src/components/Breadcrumb";
import ActionsReportTable, {
  ActionReportTableHeadType,
} from "src/components/tables/meetingTables/reports/ActionsReportTable";
import { ListSmallIcon } from "src/components/ui-icons/myTasks/ListIcon";
import { ReportIcon } from "src/components/ui-icons/sidebar";
import { searchPeopleRequest } from "src/components/ui/form/peoplePicker/api";
import { SearchUI } from "src/components/ui/Search";
import { TGCheckList } from "src/components/ui/TGCheckList";
import TGDatePicker from "src/components/ui/TGDatePicker";
import { TGDisclosure } from "src/components/ui/TGDisclosure";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { useGetSelect } from "src/hooks/redux-selectors";
import useAsyncEffect from "src/hooks/useAsyncEffect";
import ExportToExcel from "src/modules/exelExport";
import { getItems } from "src/modules/spItems/actions";
import { getItemsRequest } from "src/modules/spItems/api";
import { modifiedItemsState, selectJustUpdatedItem } from "src/modules/spItems/selectors";
import { TGCheckUsersList } from "src/pages/DashboardPage/acadia/components/Filters/CheckLists";
import { TGListWithSearch } from "src/pages/DashboardPage/acadia/components/Filters/ListsSearch";
import { LayoutWithAsideAndContent } from "src/pages/LayoutWithAsideAndContent";
import { CheckBoxListItem, UserDataRecordType, UserListItem } from "src/types/main";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { extractHashtags } from "src/utils/string.utils";
import { frequencyList } from "../../meetingsPage/components/CreateMeetingButton";
import { SubResetFilter } from "../../meetingsPage/components/MeetingCard";
import { selectCurrentUser } from "src/modules/users/selector";
import { chunkArray } from "src/utils/array.utils";
import { getNameAndSurname, nameFromEmail } from "./../../../../../utils/users.utils";
import { actionsStatus, isStrapi } from "src/api/config/systemSwitch";
import { removePrefix, prefix } from "src/utils/users.utils";
import { useUsers } from "src/hooks/useUsers";
import { getLocalItem } from "src/utils/localStorage";
import { addUsers } from "src/modules/users/actions";
type SubmitActionReportFiltersType = {
  locations: CheckBoxListItem[];
  departments: CheckBoxListItem[];
  meetingFrequency: CheckBoxListItem[];
  meetingOwners: UserListItem[];
  meetingStatuses: CheckBoxListItem[];
  meetingTitle: CheckBoxListItem[];
  createdActionDate: DateValueType;
  actionResponsibles: UserListItem[];
  dueActionDate: DateValueType;
  closedActionDate: DateValueType;
  statuses: CheckBoxListItem[];
  hashtags: CheckBoxListItem[];
};

const columns = [
  { header: "ID Совещания", key: "MeetingID", width: 20 },
  { header: "Название совещания", key: "MeetingTitle", width: 40 },
  { header: "Локация", key: "Location", width: 30 },
  { header: "Отдел", key: "Department", width: 30 },
  { header: "ID Действия", key: "ActionID", width: 20 },
  { header: "Описание действия", key: "ActionDescription", width: 50 },
  { header: "Хештеги", key: "HashTag", width: 50 },
  { header: "ФИО создателя действия", key: "ActionCreator", width: 40 },
  { header: "ФИО ответственного за действие", key: "ActionResponsible", width: 40 },
  { header: "Дата создания действия", key: "ActionCreateDate", width: 30 },
  { header: "Срок действия", key: "ActionDueDate", width: 30 },
  { header: "Статус действия", key: "ActionStatus", width: 20 },
  { header: "Дата закрытия действия", key: "ActionCloseDate", width: 30 },
  { header: "Дополнительные поля", key: "AdditionalFields", width: 50 },
  { header: "ID 5Почему", key: "5WhyID", width: 20 },
  { header: "ID Отчета об отклонении", key: "DeviationReportID", width: 20 },
  { header: "ID Поведенческого аудита", key: "BehaviorAuditID", width: 40 },
  { header: "ID Несоответствия", key: "DiscrepancyID", width: 30 },
  { header: "ID Инцидента", key: "IncidentID", width: 20 },
  { header: "ID Чек-листа", key: "ChecklistID", width: 20 },
  { header: "ID OWD", key: "OWDID", width: 20 },
  { header: "ID Сертификата/лицензии", key: "CertificateLicenseID", width: 35 },
  { header: "ID Предписания", key: "PreceptID", width: 20 },
  { header: "ID VPO чек-листа", key: "VPOChecklistID", width: 20 },
  { header: "ID GOP чек-листа", key: "GOPChecklistID", width: 20 },
] as const;

type ColumnKey = (typeof columns)[number]["key"]; // Извлекаем тип ключей из columns

type ExportDataType = {
  columns: typeof columns;
  data: Array<Partial<Record<ColumnKey, any>>>; // Каждый объект в data должен содержать ключи из ColumnKey
};

const exportTempData: ExportDataType = {
  columns,
  data: [], // Добавьте сюда данные для экспорта
};

// const typesMapping = {
//   OWD: "OWDID",
//   "5Почему": "5WhyID",
//   VPO: "VPOChecklistID",
//   GOP: "GOPChecklistID",
//   ПоведенческийАудит: "BehaviorAuditID",
//   Task: "ChecklistID",
//   DeviationReport: "DeviationReportID",
//   Discrepancy: "DiscrepancyID",
//   Incident: "IncidentID",
//   CertificateLicense: "CertificateLicenseID",
//   Precept: "PreceptID",
// } as const; // Добавляем `as const`, чтобы объект стал readonly

const submitFiltersData: SubmitActionReportFiltersType = {
  locations: [],
  departments: [],
  meetingFrequency: [],
  meetingOwners: [],
  meetingStatuses: [],
  meetingTitle: [],
  hashtags: [],
  actionResponsibles: [],
  createdActionDate: {
    startDate: new Date(),
    endDate: new Date(),
  },
  dueActionDate: {
    startDate: null,
    endDate: null,
  },
  statuses: [],
  closedActionDate: {
    startDate: null,
    endDate: null,
  },
};

type FilterKeyMap = Record<keyof SubmitActionReportFiltersType, string>;

const submitFiltersDataKeyMap: FilterKeyMap = {
  locations: "Location",
  departments: "Department",
  meetingFrequency: "Frequency",
  meetingOwners: "Owners",
  meetingStatuses: "Status",
  meetingTitle: "Title",
  hashtags: "ImportantHashTag",
  actionResponsibles: "ResponsibleEmail",
  createdActionDate: "Created",
  dueActionDate: "DateForDone",
  statuses: "Status",
  closedActionDate: "RejectDate",
} as const;

function getFiltersDataByAction(filters: SubmitActionReportFiltersType) {
  const newFiltersObject: Partial<Record<(typeof submitFiltersDataKeyMap)[keyof typeof submitFiltersDataKeyMap], any>> =
    {};

  for (const filter of Object.entries(filters)) {
    const [filterKey, filterValue] = filter as [
      keyof SubmitActionReportFiltersType,
      CheckBoxListItem[] | UserListItem[] | DateValueType,
    ];

    if (!filterValue) continue;

    // Убедимся, что ключ существует в карте
    if (filterKey in submitFiltersDataKeyMap) {
      const mappedKey = submitFiltersDataKeyMap[
        filterKey
      ] as (typeof submitFiltersDataKeyMap)[keyof typeof submitFiltersDataKeyMap];

      if (filterKey === "actionResponsibles") {
        if ((filterValue as UserListItem[]).length) {
          newFiltersObject[mappedKey] = (filterValue as UserListItem[]).map((f) => f.email.toLowerCase());
        }
      } else if (
        filterKey === "closedActionDate" ||
        filterKey === "dueActionDate" ||
        filterKey === "createdActionDate"
      ) {
        if (filterValue && (filterValue as DateRangeType).startDate && (filterValue as DateRangeType).endDate) {
          const dateObj = filterValue as DateRangeType;

          const dateFilterObject: {
            start: any;
            end: any;
          } = {
            start: null,
            end: null,
          };

          if (typeof dateObj.startDate === "string" && typeof dateObj.endDate === "string") {
            const startDate = moment(dateObj.startDate).startOf("day").toDate();
            const endDate = moment(dateObj.endDate).endOf("day").toDate();

            dateFilterObject.start = startDate;
            dateFilterObject.end = endDate;
          } else if (isDate(dateObj.startDate) && isDate(dateObj.endDate)) {
            dateFilterObject.start = moment(dateObj.startDate).startOf("day").toDate();
            dateFilterObject.end = moment(dateObj.endDate).endOf("day").toDate();
          }

          if (dateFilterObject.start && dateFilterObject.end) {
            newFiltersObject[mappedKey] = dateFilterObject;
          }
        }
      } else if (filterKey === "statuses" || filterKey === "departments" || filterKey === "locations") {
        if ((filterValue as CheckBoxListItem[]).length) {
          newFiltersObject[mappedKey] = (filterValue as CheckBoxListItem[]).map((f) => f.id);
        }
      } else if (filterKey === "hashtags" && (filterValue as CheckBoxListItem[]).length) {
        newFiltersObject[mappedKey] = (filterValue as CheckBoxListItem[]).map((f) => f.title.trim() + "*");
      }
    }
  }

  return newFiltersObject;
}

function ActionsReport() {
  const dispatch = useAppDispatch();

  const { getUser, users } = useUsers();
  const currentUser = useAppSelector(selectCurrentUser);
  const actionJustUpdated = useAppSelector((state) => selectJustUpdatedItem(state, myTaskActionsListName));

  const [list, setList] = useState<Record<ActionReportTableHeadType | "ID" | "HashTag", any>[]>([]);
  const [loading, setLoading] = useState(false);

  const [submitFilters, setSubmitFilters] = useState<SubmitActionReportFiltersType>(submitFiltersData);

  function resetSubmitFilters() {
    setSubmitFilters(submitFiltersData);
  }

  const dataToExcel = useMemo(() => {
    const excelData: Array<Partial<Record<ColumnKey, any>>> = list.map((listItem) => {
      const returnObj: Partial<Record<ColumnKey, any>> = {};

      const userCreator = (listItem.Creator && getUser(listItem.Creator)) || null;
      const userResponsible = getUser(listItem.Responsible);

      return {
        ...returnObj,
        MeetingID: listItem.Meeting.ID,
        MeetingTitle: listItem.Meeting.Title,
        Location: listItem.Location,
        Department: listItem.Department,
        ActionID: listItem.ID,
        ActionDescription: listItem.ActionDescription,
        HashTag: listItem.HashTag,
        ActionCreator:
          userCreator?.displayName ||
          `${nameFromEmail(listItem.Creator)} (${getLocalItem(listItem.Creator) || "Нет номера"})`,
        ActionResponsible:
          userResponsible?.displayName ||
          `${nameFromEmail(listItem.Responsible)} (${getLocalItem(listItem.Responsible) || "Нет номера"})`,
        ActionCreateDate: listItem.CreatedDate ? moment(listItem.CreatedDate).format("DD/MM/YYYY") : "----",
        ActionDueDate: listItem.DueDate ? moment(listItem.DueDate).format("DD/MM/YYYY") : "----",
        ActionStatus: listItem.Status.Title,
        ActionCloseDate: listItem.CloseDate ? moment(listItem.CloseDate).format("DD/MM/YYYY") : "----",
      };
    });

    return { ...exportTempData, data: excelData };
  }, [users, list]) as ExportDataType;

  useEffect(() => {
    if (list.length) {
      const userEmails = list.reduce((acc, cur) => {
        if (!acc.includes(cur.Responsible)) acc.push(cur.Responsible);

        if (!acc.includes(cur.Creator)) acc.push(cur.Creator);

        return acc;
      }, [] as string[]);

      dispatch(addUsers(userEmails));
    }
  }, [list]);

  useAsyncEffect(async () => {
    if (currentUser.email) {
      try {
        setLoading(true);

        const actionFilters = getFiltersDataByAction(submitFilters);

        const finalActionFilters: Record<string, any> = {
          ResponsibleEmail: actionFilters.ResponsibleEmail,
          Created: actionFilters.Created,
          DateForDone: actionFilters.DateForDone,
          Status: actionFilters.Status,
          RejectDate: actionFilters.RejectDate,
          ImportantHashTag: actionFilters.ImportantHashTag,
        };

        Object.keys(finalActionFilters).forEach((key) => {
          if (finalActionFilters[key] === undefined) {
            delete finalActionFilters[key];
          }
        });

        // Step 1: if meeting-related filters are active — resolve meeting IDs server-side first.
        // Title uses $containsi, Location/Department use $in — no $or conflict between them.
        const hasMeetingFilters =
          submitFilters.meetingTitle.length > 0 ||
          submitFilters.locations.length > 0 ||
          submitFilters.departments.length > 0;

        if (hasMeetingFilters) {
          const meetingFilters: Record<string, any> = {};

          if (submitFilters.meetingTitle.length > 0) {
            meetingFilters.Title = submitFilters.meetingTitle.map((t) => t.title.trim() + "*");
          }
          if (submitFilters.locations.length > 0) {
            meetingFilters.Location = submitFilters.locations.map((l) => l.id);
          }
          if (submitFilters.departments.length > 0) {
            meetingFilters.Department = submitFilters.departments.map((d) => d.id);
          }

          const meetingsResponse: any = await getItemsRequest({
            listName: myTaskMeetingsListName,
            filters: meetingFilters as any,
            switchPopulate: false,
          });

          const resolvedMeetingIds: number[] = meetingsResponse.items.map((m: any) => m.ID);

          if (!resolvedMeetingIds.length) {
            setList([]);
            return;
          }

          finalActionFilters.Meeting = resolvedMeetingIds;
        }

        // Step 2: fetch actions using server-side filters (incl. resolved meeting IDs)
        const actionResponse: any = await getItemsRequest({
          listName: myTaskActionsListName,
          filters: finalActionFilters as any,
          populateFields: [{ Meeting: ["Location", "Department"] }, "Status", "Author", "Responsible"],
        });

        if (actionResponse.items.length) {
          const tableActions: Record<ActionReportTableHeadType | "ID" | "HashTag", any>[] = [];

          actionResponse.items.forEach((action: any) => {
            if (submitFilters.closedActionDate && submitFilters.closedActionDate.startDate) {
              if (
                !(
                  action.Status.get_lookupId().toString() === actionsStatus.closed.toString() ||
                  action.Status.get_lookupId().toString() === actionsStatus.cancel.toString()
                )
              ) {
                return;
              }
            }

            const meeting = action.Meeting.get_metadata?.();

            if (!meeting) return;

            if (meeting["IsPrivate"]) {
              return; // Исключаем приватные совещания
            }

            // Фильтрация по периодичности совещания
            if (submitFilters.meetingFrequency.length > 0) {
              const frequencyMatches = submitFilters.meetingFrequency.some((freq) =>
                meeting.Frequency?.toLowerCase().includes(freq.title.toLowerCase()),
              );
              if (!frequencyMatches) return;
            }

            // Фильтрация по владельцу совещания
            if (submitFilters.meetingOwners.length > 0) {
              const owners = meeting.Owners?.toLowerCase() || "";
              const ownerMatches = submitFilters.meetingOwners.some((owner) =>
                owners.includes(owner.email.toLowerCase()),
              );
              if (!ownerMatches) return;
            }

            // Фильтрация по статусу совещания (active/archive)
            if (submitFilters.meetingStatuses.length > 0) {
              const meetingStatus = meeting.Statuses || meeting.Status;
              const statusMatches = submitFilters.meetingStatuses.some((s) =>
                s.id === 1 ? meetingStatus === "active" : meetingStatus === "archive",
              );
              if (!statusMatches) return;
            }

            const obj = {
              Meeting: { ID: meeting.id, Title: meeting.Title },
              Location: meeting.Location?.Title || "",
              Department: meeting.Department?.Title || "",
              ID: action.ID,
              ActionDescription: action.Description?.trim() || "",
              HashTag: action.ImportantHashTag?.trim() || "",
              Creator: action.AuthorEmail,
              Responsible: action.ResponsibleEmail,
              CreatedDate: action.Created,
              DueDate: action.DateForDone,
              Status: {
                Color:
                  (isStrapi && action.Status.get_metadata?.()["Color"]) || action.Status_x003a_Color?.get_lookupValue(),
                ID: action.Status.get_lookupId(),
                Title: action.Status.get_lookupValue(),
              },
              CloseDate:
                action.Status.get_lookupId().toString() === actionsStatus.closed.toString() ||
                action.Status.get_lookupId().toString() === actionsStatus.cancel.toString()
                  ? action.RejectDate
                  : null,
            };

            tableActions.push(obj);
          });

          setList(tableActions);
        } else {
          setList([]);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  }, [actionJustUpdated, JSON.stringify(submitFilters), currentUser.email]);

  useEffect(() => {
    dispatch(getItems({ listName: myTaskActionsStatusesListName }));
  }, []);

  return (
    <LayoutWithAsideAndContent
      aside={
        <ActionReportFilters
          changeSubmitFilters={(e) => setSubmitFilters(e)}
          resetSubmitFilters={resetSubmitFilters}
          submitFilters={submitFilters}
        />
      }
      content={
        <FlexCol className="w-full">
          <FlexRow className="px-7.5 h-[76px] border-b justify-between items-center shrink-0">
            <FlexCol>
              <Breadcrumbs
                items={[
                  {
                    name: "Отчеты",
                    icon: <ReportIcon />,
                  },
                  {
                    name: "Отчет по действиям",
                    icon: <ListSmallIcon />,
                  },
                ]}
              />
            </FlexCol>
            <FlexCol>
              <ExportToExcel
                exportData={dataToExcel}
                fileName={`Отчет по действиям`}
                type={"action_reports"}
                disabled={loading}
              />
            </FlexCol>
          </FlexRow>
          <StatusCounters items={list} />
          <ActionReportTableWrapper
            list={list}
            loading={loading}
            // page={page}
            // changePage={(page: number) => {
            //   setPage(page);
            //   pageRef.current = page;
            // }}
          />
        </FlexCol>
      }
    />
  );
}

export default ActionsReport;

function StatusCounters({ items }: { items: any[] }) {
  const counters = items.reduce(
    (acc, item) => {
      if (item.Status.ID.toString() === actionsStatus.notStart.toString()) {
        acc.unstarted += 1;
      } else if (item.Status.ID.toString() === actionsStatus.process.toString()) {
        acc.inProcess += 1;
      } else if (item.Status.ID.toString() === actionsStatus.old.toString()) {
        acc.expired += 1;
      } else if (item.Status.ID.toString() === actionsStatus.cancel.toString()) {
        acc.cancel += 1;
      } else if (item.Status.ID.toString() === actionsStatus.closed.toString()) {
        acc.closed += 1;
      }
      return acc;
    },
    { unstarted: 0, inProcess: 0, expired: 0, cancel: 0, closed: 0 },
  );

  return (
    <FlexRow className="px-7.5 pt-7.5 mb-5">
      <FlexRow className="justify-around items-center px-5 py-4 w-full bg-white rounded-lg shadow-custom">
        <StatusBadge color="#DEE2E6" count={counters.unstarted} label="Не начато" />
        <StatusBadge color="#F2A900" count={counters.inProcess} label="В процессе" />
        <StatusBadge color="#BA0C2F" count={counters.expired} label="Просрочено" />
        <StatusBadge color="#637381" count={counters.cancel} label="Отменено" />
        <StatusBadge color="#22AD5C" count={counters.closed} label="Закрыто" />
      </FlexRow>
    </FlexRow>
  );
}

function ActionReportTableWrapper({
  list,
  loading,
}: // page,
// changePage,
{
  list: Record<ActionReportTableHeadType | "ID" | "HashTag", any>[];
  loading: boolean;
  // page: number;
  // changePage: (page: number) => void;
}) {
  return (
    <div className="px-7.5 ">
      <ActionsReportTable
        list={list}
        loading={loading}
        // page={page} changePage={changePage}
      />
    </div>
  );
}

interface StatusBadgeProps {
  color: string; // Цвет для иконки и текста
  label: ReactNode; // Текст, например, "Просрочено"
  count: ReactNode; // Количество элементов
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ color, label, count }) => {
  return (
    <div className={`text-[${color}] flex space-x-2.5 items-center`}>
      <span style={{ backgroundColor: color }} className={`rounded-full w-2.5 h-2.5`}></span>
      <span>{label}</span>
      <span className="text-[18px] font-medium">{count}</span>
    </div>
  );
};

function ActionReportFilters({
  submitFilters,
  changeSubmitFilters,
  resetSubmitFilters,
}: {
  submitFilters: SubmitActionReportFiltersType;
  changeSubmitFilters: (e: SubmitActionReportFiltersType) => void;
  resetSubmitFilters: () => void;
}) {
  const {
    locations,
    departments,
    meetingFrequency,
    meetingOwners,
    meetingStatuses,
    meetingTitle,
    createdActionDate,
    dueActionDate,
    statuses,
    closedActionDate,
    actionResponsibles,
    hashtags,
  } = submitFilters;

  const dispatch = useAppDispatch();
  const { data: myTaskActionsStatuses } = useGetSelect(myTaskActionsStatusesListName);
  const { data: locationsResponseData, status: locationsStatus } = useGetSelect(myTasksLocationsListName);
  const { data: departmentsResponseData, status: departmentsStatus } = useGetSelect(myTasksDepartmentsListName);

  const [locationOptions, setLocationOptions] = useState<CheckBoxListItem[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<CheckBoxListItem[]>([]);
  const [dependLoading, setDependLoading] = useState<boolean>(false);
  const [filterLoading, setFilterLoading] = useState<boolean>(false);
  const firstSelectedFilterRef = useRef<"locations" | "departments" | null>(null);
  const firstFilterSnapshotRef = useRef<{ type: "locations" | "departments" | null; values: number[] }>({
    type: null,
    values: [],
  });

  const meetingsResponseData = useGetSelect(myTaskMeetingsListName);

  function checkListItem(key: keyof SubmitActionReportFiltersType, value: CheckBoxListItem) {
    const values = submitFilters[key] as CheckBoxListItem[];

    let newValue = [...values];

    if (newValue.length > 0 && newValue.find((f) => f.id === value.id)) {
      const filtered = values.filter((n) => n.id !== value.id);

      newValue = filtered;
    } else {
      newValue.push(value);
    }

    changeSubmitFilters({ ...submitFilters, [key]: newValue });
  }

  function checkListDateItem(key: keyof SubmitActionReportFiltersType, value: DateValueType) {
    changeSubmitFilters({ ...submitFilters, [key]: value });
  }

  function checkListUserItem(key: keyof SubmitActionReportFiltersType, value: UserListItem) {
    const values = submitFilters[key] as UserListItem[];

    let newValue = [...values];
    if (newValue.length > 0 && newValue.find((f) => f.id === value.id)) {
      const filtered = values.filter((n: any) => n.id !== value.id);
      newValue = filtered;
    } else {
      newValue.push(value);
    }
    changeSubmitFilters({ ...submitFilters, [key]: newValue });
  }

  const resetFilters = () => {
    firstSelectedFilterRef.current = null;
    firstFilterSnapshotRef.current = { type: null, values: [] };
    setLocationOptions(locationOptions.map((f) => ({ ...f, disabled: false })));
    setDepartmentOptions(departmentOptions.map((f) => ({ ...f, disabled: false })));
  };

  // Чистит всё
  function clearAll() {
    resetSubmitFilters();
    resetFilters();
  }

  function reset(key: keyof typeof submitFilters, value: any) {
    changeSubmitFilters({ ...submitFilters, [key]: value });
  }

  const isFiltersEmpty = useMemo(() => {
    const isEmpty = locations.length > 0 || departments.length > 0 || meetingFrequency.length > 0;

    return isEmpty;
  }, [JSON.stringify(submitFilters)]);

  // useAsyncEffect(async () => {
  //   const myTasksDependResponse = await getItemsRequest({ listName: myTasksDependListName });
  // }, []);

  useAsyncEffect(async () => {
    const locCount = submitFilters.locations.length;
    const deptCount = submitFilters.departments.length;

    // Nothing selected — reset everything synchronously, no request needed.
    if (locCount === 0 && deptCount === 0) {
      firstSelectedFilterRef.current = null;
      firstFilterSnapshotRef.current = { type: null, values: [] };
      setFilterLoading(false);
      setDependLoading(false);
      return;
    }

    // Determine which filter is "first".
    // Only one selected → that one becomes first.
    // Both selected   → keep the existing first (don't overwrite).
    // Both selected but ref is still null (e.g. state restore) → default to locations.
    if (locCount > 0 && deptCount === 0) {
      firstSelectedFilterRef.current = "locations";
    } else if (deptCount > 0 && locCount === 0) {
      firstSelectedFilterRef.current = "departments";
    } else if (locCount > 0 && deptCount > 0 && firstSelectedFilterRef.current === null) {
      firstSelectedFilterRef.current = "locations";
    }

    const effectiveFirst = firstSelectedFilterRef.current;
    if (!effectiveFirst) return;

    // Compare with the previous first-filter snapshot to decide whether to
    // re-run the dependency query. When both filters are selected and only
    // the secondary filter changed, the dependency mapping for the secondary
    // filter is already correct — no request or loading needed.
    const currentFirstValues =
      effectiveFirst === "locations"
        ? submitFilters.locations.map((l) => Number(l.id))
        : submitFilters.departments.map((d) => Number(d.id));

    const snapshot = firstFilterSnapshotRef.current;
    const firstFilterUnchanged =
      snapshot.type === effectiveFirst &&
      currentFirstValues.length === snapshot.values.length &&
      currentFirstValues.every((v, i) => v === snapshot.values[i]);

    if (firstFilterUnchanged && locCount > 0 && deptCount > 0) {
      return; // Only secondary filter changed — skip request and loading.
    }

    // Persist the snapshot so subsequent renders can detect future changes.
    firstFilterSnapshotRef.current = { type: effectiveFirst, values: currentFirstValues };

    // Always query by the FIRST filter only so that the second filter's
    // options are never incorrectly disabled after both are selected.
    const selected = {
      locations: submitFilters.locations.map((l) => Number(l.id)),
      departments: submitFilters.departments.map((d) => Number(d.id)),
    };

    const filters: { Location?: number[]; Departament?: number[] } =
      effectiveFirst === "locations" && locCount > 0
        ? { Location: selected.locations }
        : effectiveFirst === "departments" && deptCount > 0
          ? { Departament: selected.departments }
          : {};

    if (Object.keys(filters).length === 0) return;

    try {
      setFilterLoading(true);
      setDependLoading(true);

      const { items: dependItems } = await getItemsRequest({
        listName: myTasksDependListName,
        filters,
      });

      const resultData = {
        locations: new Set<number>(),
        departments: new Set<number>(),
      };

      if (dependItems.length > 0) {
        const chunks = chunkArray(dependItems, 25);

        const resultResponseData = await Promise.all(
          chunks.map(async (chunk) => {
            const modifiedItems = modifiedItemsState(chunk, myTasksDependListName);

            return modifiedItems.reduce(
              (acc, item) => {
                acc.locations.add(item.Location.ID);
                acc.departments.add(item.Departament.ID);

                return acc;
              },
              {
                locations: new Set<number>(),
                departments: new Set<number>(),
              },
            );
          }),
        );

        resultResponseData.forEach((item) => {
          item.locations.forEach((id) => resultData.locations.add(id));
          item.departments.forEach((id) => resultData.departments.add(id));
        });
      }

      setLocationOptions(
        locationsResponseData.map((loc) => ({
          id: loc.ID,
          title: loc.Title,
          rest: loc,
          disabled: effectiveFirst !== "locations" && !resultData.locations.has(loc.ID),
        })),
      );

      setDepartmentOptions(
        departmentsResponseData.map((dep) => ({
          id: dep.ID,
          title: dep.Title,
          rest: dep,
          disabled: effectiveFirst !== "departments" && !resultData.departments.has(dep.ID),
        })),
      );
    } catch (error) {
      console.error(error);
    } finally {
      setFilterLoading(false);
      setDependLoading(false);
    }
  }, [
    locationsResponseData,
    departmentsResponseData,
    submitFilters.locations,
    submitFilters.departments,
    locationsStatus,
    departmentsStatus,
  ]);

  // Фильтры
  useEffect(() => {
    if (locationsStatus === "SUCCESS") {
      setLocationOptions(locationsResponseData.map((f) => ({ id: f.ID, title: f.Title, rest: f })));
    }

    if (departmentsStatus === "SUCCESS") {
      setDepartmentOptions(departmentsResponseData.map((f) => ({ id: f.ID, title: f.Title, rest: f })));
    }
  }, [locationsResponseData, departmentsResponseData, locationsStatus, departmentsStatus]);

  useEffect(() => {
    // Lists
    dispatch(getItems({ listName: myTasksLocationsListName }));
    dispatch(getItems({ listName: myTasksDepartmentsListName }));
    dispatch(getItems({ listName: myTaskMeetingsListName }));
  }, []);

  return (
    <FlexCol className="overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] h-full">
      {isFiltersEmpty && (
        <FlexRow className="flex-nowrap gap-x-2 items-center p-5 border-b cursor-pointer group" onClick={clearAll}>
          <FlexCol className="group-hover:underline">Сбросить все фильтры</FlexCol>
          <FlexCol>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_381_6476)">
                <path
                  d="M7.9999 7.19998L1.8999 1.09998C1.6749 0.874975 1.3249 0.874975 1.0999 1.09998C0.874902 1.32498 0.874902 1.67497 1.0999 1.89997L7.1999 7.99998L1.0999 14.1C0.874902 14.325 0.874902 14.675 1.0999 14.9C1.3249 15.125 1.6749 15.125 1.8999 14.9L7.9999 8.79998L14.0999 14.9C14.3249 15.125 14.6749 15.125 14.8999 14.9C14.9999 14.8 15.0749 14.65 15.0749 14.5C15.0749 14.35 15.0249 14.2 14.8999 14.1L8.7999 7.99998L14.8999 1.89997C14.9999 1.79997 15.0749 1.64997 15.0749 1.49998C15.0749 1.34998 15.0249 1.19998 14.8999 1.09998C14.6749 0.874975 14.3249 0.874975 14.0999 1.09998L7.9999 7.19998Z"
                  fill="#637381"
                />
              </g>
              <defs>
                <clipPath id="clip0_381_6476">
                  <rect width="16" height="16" fill="white" transform="translate(0 16) rotate(-90)" />
                </clipPath>
              </defs>
            </svg>
          </FlexCol>
        </FlexRow>
      )}
      <TGDisclosure title="Локация" count={locations.length} disabled={filterLoading || locationsStatus === "LOADING"}>
        <TGListWithSearch
          listLoading={dependLoading}
          listData={locationOptions}
          items={locations}
          checkedItems={(value) => checkListItem("locations", value)}
        />
        <SubResetFilter resetFilter={() => reset("locations", [])} />
      </TGDisclosure>
      <TGDisclosure
        title="Отдел"
        count={departments.length}
        disabled={filterLoading || departmentsStatus === "LOADING"}
      >
        <TGListWithSearch
          listLoading={dependLoading}
          listData={departmentOptions}
          items={departments}
          checkedItems={(value) => checkListItem("departments", value)}
        />
        <SubResetFilter resetFilter={() => reset("departments", [])} />
      </TGDisclosure>
      <TGDisclosure title="Периодичность совещания" count={meetingFrequency.length}>
        <TGCheckList
          list={frequencyList.map((status) => ({ id: status.id, title: status.name }))}
          items={meetingFrequency}
          onChecked={(value) => checkListItem("meetingFrequency", value)}
        />
        <SubResetFilter resetFilter={() => reset("meetingFrequency", [])} />
      </TGDisclosure>
      <TGDisclosure title="Владелец совещания" count={meetingOwners.length}>
        <FilterUser
          selected={meetingOwners}
          checkEmployees={(value) => checkListUserItem("meetingOwners", value)}
          reset={() => reset("meetingOwners", [])}
        />
      </TGDisclosure>
      <TGDisclosure title="Статус совещания" count={meetingStatuses.length}>
        <TGCheckList
          list={[
            { id: 1, title: "Активное" },
            { id: 2, title: "Архивное" },
          ]}
          items={meetingStatuses}
          onChecked={(value) => checkListItem("meetingStatuses", value)}
        />
        <SubResetFilter resetFilter={() => reset("meetingStatuses", [])} />
      </TGDisclosure>
      <TGDisclosure title="Название совещания" count={meetingTitle.length}>
        <TGListWithSearch
          listData={meetingsResponseData.data.map((d) => ({ id: d.ID.toString(), title: d.Title, rest: d }))}
          items={meetingTitle}
          checkedItems={(value) => checkListItem("meetingTitle", value)}
        />
        <SubResetFilter resetFilter={() => reset("meetingTitle", [])} />
      </TGDisclosure>
      <TGDisclosure title="Ответственный за действие" count={actionResponsibles.length}>
        <FilterUser
          selected={actionResponsibles}
          checkEmployees={(value) => checkListUserItem("actionResponsibles", value)}
          reset={() => reset("actionResponsibles", [])}
        />
      </TGDisclosure>
      <TGDisclosure title="Дата создания действия" count={createdActionDate?.startDate ? 1 : 0} defaultOpen={true}>
        <FlexCol className="relative z-[101] w-full gap-y-3.5">
          <h4 className={"font-normal"}>От и До</h4>
          <TGDatePicker
            value={createdActionDate}
            onChange={(value) =>
              checkListDateItem(
                "createdActionDate",
                value
                  ? (value as DateValueType)
                  : {
                      startDate: new Date(),
                      endDate: new Date(),
                    },
              )
            }
            popoverDirection="down"
          />
          <SubResetFilter
            resetFilter={() =>
              reset("createdActionDate", {
                startDate: new Date(),
                endDate: new Date(),
              })
            }
          />
        </FlexCol>
      </TGDisclosure>
      <TGDisclosure title="Срок выполнения действия" count={dueActionDate?.startDate ? 1 : 0}>
        <FlexCol className="relative z-[100] w-full gap-y-3.5">
          <h4 className={"font-normal"}>От и До</h4>
          <TGDatePicker
            value={dueActionDate}
            onChange={(value) => checkListDateItem("dueActionDate", value)}
            popoverDirection="down"
          />
          <SubResetFilter resetFilter={() => reset("dueActionDate", { startDate: null, endDate: null })} />
        </FlexCol>
      </TGDisclosure>
      <TGDisclosure title="Статус действия" count={statuses.length}>
        <TGCheckList
          list={myTaskActionsStatuses.filter((f) => f.Status).map((m) => ({ id: m.ID, title: m.Title, rest: m }))}
          items={statuses}
          onChecked={(value) => checkListItem("statuses", value)}
        />
        <SubResetFilter resetFilter={() => reset("statuses", [])} />
      </TGDisclosure>
      <TGDisclosure title="Дата закрытия действия" count={closedActionDate?.startDate ? 1 : 0}>
        <FlexCol className="relative z-[99] w-full gap-y-3.5">
          <h4 className={"font-normal"}>От и До</h4>
          <TGDatePicker
            value={closedActionDate}
            onChange={(value) => checkListDateItem("closedActionDate", value)}
            popoverDirection="down"
          />
          <SubResetFilter resetFilter={() => reset("closedActionDate", { startDate: null, endDate: null })} />
        </FlexCol>
      </TGDisclosure>
      <TGDisclosure title="Хештеги" count={hashtags.length}>
        <FilterHashtags
          selected={hashtags}
          checkHashtags={(value) => checkListItem("hashtags", value)}
          reset={() => reset("hashtags", [])}
        />
      </TGDisclosure>
    </FlexCol>
  );
}

export function FilterUser({
  selected,
  checkEmployees,
  reset,
  allowedEmails,
}: {
  selected: UserListItem[];
  checkEmployees: (value: UserListItem) => void;
  reset: () => void;
  allowedEmails?: Set<string> | null;
}) {
  const [employees, setEmployees] = useState<UserListItem[]>([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  function handleSearch(value: string) {
    setQuery(value);
  }

  function onReset() {
    setEmployees([]);
    setQuery("");
    setLoading(false);
    reset();
  }

  useAsyncEffect(async () => {
    let results: UserListItem[] = [];

    setLoading(true);

    try {
      if (query.length > 3) {
        const users = (await searchPeopleRequest(query + "*")) as unknown as UserDataRecordType[];

        results = users.map((user) => ({
          id: user.id,
          title: `${getNameAndSurname(user.PreferredName, removePrefix(user.AccountName, prefix))} (${
            user.apiGlobalID || user.UserName || "Нет номера"
          })`,
          avatar: user.PictureUrl,
          email: removePrefix(user.AccountName, prefix),
          shortName: `${getNameAndSurname(user.PreferredName, removePrefix(user.AccountName, prefix), true)}`,
        }));
      }

      setEmployees(results);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [query]);

  const searchResults =
    allowedEmails && allowedEmails.size > 0
      ? employees.filter((u) => u.email && allowedEmails.has(u.email.toLowerCase()))
      : employees;

  const searchResultIds = new Set(searchResults.map((u) => u.id));
  const selectedNotInSearch = selected.filter((s) => !searchResultIds.has(s.id));
  const displayEmployees = [...selectedNotInSearch, ...searchResults];

  return (
    <>
      <SearchUI
        placeholder="Введите имя сотрудника"
        defaultValue={query}
        onClick={handleSearch}
        search={true}
        resetButton={false}
        disabled={loading}
        label={"ФИО сотрудника"}
        labelClass="text-black"
        inputClass="px-2.5 font-normal"
      />
      <TGCheckUsersList list={displayEmployees} items={selected} onChecked={checkEmployees} />
      <SubResetFilter resetFilter={onReset} />
    </>
  );
}

// Нужно — нормализовать, убрав # перед сравнением
const normalizeHashtag = (s: string) => (s.startsWith("#") ? s : `#${s}`);

export function FilterHashtags({
  selected,
  checkHashtags,
  reset,
}: {
  selected: CheckBoxListItem[];
  checkHashtags: (value: CheckBoxListItem) => void;
  reset: () => void;
}) {
  const [items, setItems] = useState<CheckBoxListItem[]>([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  function handleSearch(value: string) {
    setQuery(value);
  }

  function onReset() {
    setItems([]);
    setQuery("");
    setLoading(false);
    reset();
  }

  useAsyncEffect(async () => {
    let results: CheckBoxListItem[] = [];

    if (query.length === 0) {
      setItems([]);
      return;
    }

    // firstElement uses the normalised #tag format so its id always matches
    // the ids returned by extractHashtags from the backend (which include #).
    const firstElement = { id: normalizeHashtag(query), title: normalizeHashtag(query) };

    setItems([firstElement]);
    setLoading(true);

    try {
      const myTaskActions = await getItemsRequest({
        listName: myTaskActionsListName,
        filters: { ImportantHashTag: query + "*" },
        viewFields: ["ImportantHashTag"],
        switchViewFields: true,
      });

      if (myTaskActions.items.length) {
        results = myTaskActions.items.reduce((acc, item) => {
          if (item.ImportantHashTag) {
            const hashtags = extractHashtags(item.ImportantHashTag);

            hashtags.forEach((tag) => {
              if (!acc.find((a) => a.id === tag)) {
                acc.push({ id: tag, title: tag });
              }
            });
          }

          return acc;
        }, [] as CheckBoxListItem[]);
      }

      // firstElement is already normalised to #tag so the exact id comparison
      // correctly deduplicates it against backend results.
      results = results.reduce(
        (acc, item) => {
          if (item.id !== firstElement.id) {
            acc.push(item);
          }
          return acc;
        },
        [firstElement] as CheckBoxListItem[],
      );

      setItems(results);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [query]);

  return (
    <>
      <SearchUI
        placeholder="Введите хэштег"
        defaultValue={query}
        onClick={handleSearch}
        search={true}
        resetButton={false}
        // loading={loading}
        // disabled={loading}
        label={""}
        labelClass="text-black"
        inputClass="font-normal pl-2.5"
      />
      <TGCheckList list={items} items={selected} onChecked={checkHashtags} loading={loading} />
      <SubResetFilter resetFilter={onReset} />
    </>
  );
}
